import axios from "axios";

export default {
    get: (ctrl) => axios.get("/api/notifications/get", ctrl ? { signal: ctrl.signal } : null),
    save: (obj, ctrl) => axios.post("/api/notifications/save", obj, ctrl ? { signal: ctrl.signal } : null),
};
